
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.588 20.833a.997.997 0 00-1.39.25l-5.4 7.775-4.059-9.349a.994.994 0 00-.92-.597h-1.17l5.03-13.58a.987.987 0 00-.59-1.274.994.994 0 00-1.28.587l-5.28 14.267h-.569l1.41-14.556a.996.996 0 00-.9-1.085.992.992 0 00-1.09.896l-1.43 14.755H20.432c-.4 0-.76.239-.92.597l-4.059 9.349-5.4-7.776a.99.99 0 00-1.389-.249.989.989 0 00-.25 1.384l6.31 9.09 4.728 23.694c.09.468.5.797.98.797H38.83c.48 0 .89-.339.98-.797l4.73-23.695 6.308-9.09a1.01 1.01 0 00-.26-1.393zm-29.506.07H38.17l3.91 9H17.173l3.91-9zM38 53.806H21.242l-4.38-21.902H42.37l-4.37 21.902z"}})])
          )
        }
      }
    